import { EditStudent } from "./Edit";

export const ViewStudent = () => EditStudent({ editingDisabled: true });
